import lazyWithPreload from "../../../../shared/utils/lazyWithPreload";

const SolicitacaoRoute = lazyWithPreload(() =>
  import("app/Comercial/components/ListaGrupoCliente/SolicitacoesEdicao/screens/Solicitacoes")
);

export default SolicitacaoRoute;
